module.exports = __webpack_public_path__ + "static/assets/811decf5ffecd9e53401aa35872e3241.png";